import dashboard from './dashboard';
import masters from './master';
import organization from './organization';
import advanced from './advanced';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
	items: [dashboard, organization, masters, advanced],
};

export default menuItems;
